<template>
  <b-container>
    <!-- modal borrar objetivo de la unidad -->
    <b-modal v-model="ModalBorrarCurricula" persistent title=" Confirmación" size="lg" centered>
      <b-container fluid>
        <b-row class="m-1 text-left">
          <b-col cols="12">
            ¿ Estás seguro de eliminar la currícula: <b>"{{ currentCurriculaNombre }}"</b> ?
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" size="sm" class="float-right" @click=" ModalBorrarCurricula = false">
            Cancelar
          </b-button>
          <b-button variant="danger" size="sm" class="float-right mx-2" @click="borrarCurricula()">
            Eliminar
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- modal crear nuevo elemento -->
    <b-modal no-close-on-backdrop centered size="xl" hide-footer ref="ModalCrearCurricula"
      :title="curricula_form.editar ? 'Editando currícula' : 'Creando currícula nueva'" 
      v-model="ModalCrearCurricula" 
      persistent
      scrollable>
      
      <b-card tag="article" class="mb-2">
        <b-alert show variant="primary" class="p-3 text-justify">
          <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="currentColor"
            class="bi bi-info-circle-fill mr-2" viewBox="0 0 16 16">
            <path
              d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
          </svg>
          A continuación especifique un nombre descriptivo y una descripción de su currícula
        </b-alert>
        
        <div class="col-sm-12">
          <b-form>
            <b-row>
              <b-col md="8">
                <b-form-input ref="nombreCurriculaInput" class="my-2"
  v-model="curricula_form.nombre_curricula" type="text" 
  placeholder="Ingresa el nombre de la Currícula">
</b-form-input>

                <b-form-select class="my-2" v-model="curricula_form.tipo"
                  label="Tipo de curricula" :options="tipo_curricula"></b-form-select>

                <b-form-textarea ref="curricula_form.descripcion" v-model="curricula_form.descripcion"
                  placeholder="Descripción de la currícula (deje en blanco si no lo requiere)..." 
                  rows="3" max-rows="6">
                </b-form-textarea>

                <b-row class="d-flex align-items-start justify-content-start my-2">
                  <b-col>
                    <b-form-datepicker locale="es" placeholder="Fecha vigencia inicial"
                      v-model="curricula_form.fecha_vigencia_inicio" size="sm" label-help='' 
                      label-today-button='Hoy' today-button label-no-date-selected='No se ha elegido fecha'>
                    </b-form-datepicker>
                  </b-col>
                  <b-col>
                    <b-form-datepicker locale="es" placeholder="Fecha vigencia finalización"
                      v-model="curricula_form.fecha_vigencia_finalizacion" size="sm" label-help=''
                      label-today-button='Hoy' today-button label-no-date-selected='No se ha elegido fecha'>
                    </b-form-datepicker>
                  </b-col>
                </b-row>
              </b-col>
              
              <b-col md="4">
                <!-- Gestión de imágenes -->
                <div v-if="curricula_form.editar && curricula_form.imagen && !curricula_form.reemplazarImagen" 
                     class="d-flex flex-column align-items-center justify-content-center mb-3">
                  <b-img :src="curricula_form.imagen" fluid thumbnail class="mb-2" 
                         style="max-height: 200px; object-fit: contain;"></b-img>
                  <div class="d-flex flex-wrap justify-content-center gap-2">
    
                    <b-button @click="quitarImagen()" variant="outline-danger" size="sm">
                      <i class="fas fa-trash mr-1"></i> Quitar
                    </b-button>
                  </div>
                </div>
                
                <div v-else>
                  <b-form-file 
                    v-model="curricula_form.imagenNueva"
                    :state="Boolean(curricula_form.imagenNueva)"
                    placeholder="Selecciona una imagen..."
                    drop-placeholder="Arrastra la imagen aquí"
                    accept="image/*"
                    class="mb-2"
                    @change="onImagenSeleccionada"
                  ></b-form-file>
                  
                  <small class="text-muted">
                    Formatos aceptados: JPG, PNG, GIF. Tamaño máximo: 2MB
                  </small>
                  
                  <!-- Mostrar mensaje cuando se ha quitado la imagen -->
                  <b-alert v-if="curricula_form.quitarImagenExistente" show variant="warning" class="mt-2 p-2 small">
                    <i class="fas fa-exclamation-triangle mr-1"></i> 
                    La imagen existente será eliminada al guardar los cambios.
                  </b-alert>
                </div>
              </b-col>
            </b-row>

            <b-row class="d-flex align-items-start justify-content-start my-3">
              <div class="w-100">
                <b-button variant="primary" size="sm" class="float-right" @click="cerrarModalCrearCurricula()">
                  Cancelar
                </b-button>

                <b-button v-if="curricula_form.editar" variant="info" size="sm" class="float-right mx-2"
                  @click="actualizarCurricula()">
                  Actualizar
                </b-button>
                <b-button v-else variant="success" size="sm" class="float-right mx-2"
                  @click="guardarCurricula()">
                  Guardar
                </b-button>
              </div>
            </b-row>
          </b-form>
        </div>
      </b-card>
    </b-modal>
    
    <b-row>
      <b-col cols="12">
        <div class="card-block">
          <div class="card-body p-2">
            <div class="d-flex align-items-center justify-content-center flex-column p-2">
                <h1 class="mt-5 mb-4">
                  Te damos la bienvenida a eleva
                </h1>              
                <h3 class="text-center mb-5">
                  Aquí podrás activar tus conocimientos con cursos de herramientas digitales, tutoriales de apps
                  educativas y charlas sobre metodologías de aprendizaje activo. ¡Es hora de elevar tu enseñanza!
                </h3>              
            </div>

            <b-alert v-if="$store.getters.usuario.role_id == 1" class="p-3" show variant="info" dismissible>
              <div>Puedes administrar tus Programas de Formación y organizar el contenido de cada uno.</div>
            </b-alert>

            <b-row v-if="$store.getters.usuario.role_id == 1" class="d-flex align-items-end justify-content-end my-3">
              <div class="col-sm-12 col-md-6 text-right ">
                <b-button @click="showModalCrearCurricula" class="btn-studioAPP" variant="outline-warning"> 
                  <i class="fas fa-plus mr-1"></i> Crear nuevo Programa de Formación
                  
                </b-button>
              </div>
            </b-row>

            <b-row class="d-flex align-items-end justify-content-center my-1">
              <div class="col-sm-4 mt-2 mb-5 p-0">
                <b-form-input id="filter-input" v-model="filter" type="search" placeholder="Buscar">
                </b-form-input>
              </div>
            </b-row>

            <div v-if="isLoading == true">
              <b-alert class=" mx-4 p-4" show variant="primary" dismissible>
                <div>Unos segundos, estamos cargando la información</div>
              </b-alert>
            </div>
          </div>
        </div><!-- card block -->
        <div v-if="!isLoading">
          <div class="row row-cols-1 row-cols-md-3 g-4">
            <!-- iteramos solo los items de la página actual -->
            <div v-for="(item, index) in paginatedItems" :key="index" class="col-12 col-md-6 col-lg-4 mb-4">
              <div class="card shadow-sm rounded overflow-hidden border-0 h-100 card-hover d-flex flex-column">
                <div class="position-relative" style="height: 160px;">
                  <!-- CORRECCIÓN: Usar item.imagen en lugar de item.url_video_presentacion -->
                  <img v-if="item.imagen" :src="item.imagen" 
                       class="card-img-top w-100 h-100 object-fit-cover" 
                       :alt="'Imagen de ' + item.nombre_curricula" />
                  <img v-else-if="item.url_video_presentacion" :src="item.url_video_presentacion" 
                       class="card-img-top w-100 h-100 object-fit-cover" 
                       :alt="'Imagen de ' + item.nombre_curricula" />
                  <img v-else
                    src="https://lh7-rt.googleusercontent.com/docsz/AD_4nXfKUREvE_Jfjvz6JfT_aR_CItUTpws4hrJuB4DUB_Zzo6_7uEH8NsjpOLYxkbiyC82myRXfItIL9FfjklLAy61Kq_wZJfwGZMFrIPPNUZKgrzjgCq61iNo4E6BoZetZmsDK1wcszQ?key=fsT7wjJUqvQOavCNRx9n-w"
                    class="card-img-top w-100 h-100 object-fit-cover" alt="Imagen predeterminada del curso" />
                </div>
                <div class="card-body border-start border-4 d-flex flex-column"
                  :class="item.expired == 1 ? 'border-secondary' : 'border-danger'">
                  <div class="d-flex justify-content-between align-items-start mb-3">
                    <div>
                      <h5 class="card-title mb-1 fw-bold text-dark">
                        {{ item.nombre_curricula }}
                      </h5>
                      <p class="card-subtitle text-muted small">Certificación</p>
                    </div>
                    <span class="badge" :class="item.expired == 1 ? 'bg-secondary' : 'bg-danger'">
                      {{ item.expired == 1 ? 'Expirada' : 'Online' }}
                    </span>
                  </div>

                  <div class="card-text-container flex-grow-1">
                    <p class="card-text text-muted mb-3">
                      {{ item.descripcion }}
                    </p>
                  </div>

                  <div class="card-footer-custom mt-auto">
                    <small class="text-muted">{{ item.totalContenidos }} contenidos</small>

                    <div v-if="$store.getters.usuario.role_id == 1">
                      <div class="btn-group" role="group">
                        <b-button variant="outline-primary" size="sm" @click="irCursosCurricula(item)">
                           Gestionar
                        </b-button>
                        <b-button variant="outline-info" size="sm" @click="EditMode(item)">
                         Editar
                        </b-button>
                        <b-button variant="outline-danger" size="sm" @click="ShowModalBorrarCurricula(item)">
                           Eliminar 
                        </b-button>
                      </div>
                    </div>
                    <div v-else>
                      <b-button v-if="item.expired == 1" variant="link" size="sm" disabled>
                        <small><i>Expirada ⚠️</i></small>
                      </b-button>
                      <b-button v-else variant="link" @click="irCursosCurricula(item)">
                        Comenzar
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                          class="bi bi-chevron-right ms-1" viewBox="0 0 16 16">
                          <path fill-rule="evenodd"
                            d="M6.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 6.646 2.354a.5.5 0 0 1 0-.708z" />
                        </svg>
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- paginación -->
          <div class="d-flex justify-content-end mt-4">
            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="fill" size="sm" />
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import toast from "../../mixins/ToastMixin.js";
import Bugsnag from "@bugsnag/js";

export default {
  mixins: [toast],
  mounted() {
    this.getCurriculas();
  },
  data() {
    return {
      tipo_curricula: [
        { value: "0", text: "Elegir tipo de curricula", disabled: true },
        { value: "1", text: "Autogestivo" },
        { value: "2", text: "En vivo" },
        { value: "3", text: "Mixto" },
      ],
      isLoading: true,
      currentCurriculaId: 0,
      currentCurriculaNombre: "",
      ModalBorrarCurricula: false,

      curricula_form: {
        nombre_curricula: "",
        descripcion: "",
        tipo: 0,
        editar: false,
        fecha_vigencia_inicio: "",
        fecha_vigencia_finalizacion: "",
        imagen: null, // URL de la imagen actual (en edición)
        imagenNueva: null, // Archivo de imagen nueva
        reemplazarImagen: false, // Bandera para forzar reemplazo
        quitarImagenExistente: false, // Bandera para indicar que se quiere quitar la imagen
      },
      ModalCrearCurricula: false,
      itemsCurriculas: [],

      currentPage: 1,
      perPage: 9,
      filter: null,

      // Configuración de validación
      maxImageSizeMB: 2, // Límite de 2MB
    };
  },
  computed: {
    filteredItems() {
      if (!this.filter) {
        return this.itemsCurriculas;
      }
      const searchTerm = this.filter.toLowerCase();
      return this.itemsCurriculas.filter((item) => {
        const nombre = item.nombre_curricula || "";
        const descripcion = item.descripcion || "";
        return (
          nombre.toLowerCase().includes(searchTerm) ||
          descripcion.toLowerCase().includes(searchTerm)
        );
      });
    },
    totalRows() {
      return this.filteredItems.length;
    },
    paginatedItems() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredItems.slice(start, end);
    },
  },
  watch: {
    filter() {
      this.currentPage = 1;
    },
  },
  methods: {
    irCursosCurricula(curricula = []) {
      this.$router.push({
        name: "CursosCurricula",
        params: { curricula: curricula, is_dashboard: true },
      });
    },

    validarImagen(file) {
      const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "image/webp", "image/gif"];
      if (!allowedTypes.includes(file.type)) {
        this.toast(
          "b-toaster-bottom-center",
          true,
          "Formato inválido. Solo se permiten imágenes JPG, PNG, GIF o WEBP.",
          "warning"
        );
        return false;
      }
      const maxSizeBytes = this.maxImageSizeMB * 1024 * 1024;
      if (file.size > maxSizeBytes) {
        this.toast(
          "b-toaster-bottom-center",
          true,
          `La imagen supera el tamaño máximo permitido de ${this.maxImageSizeMB} MB.`,
          "warning"
        );
        return false;
      }
      return true;
    },

    onImagenSeleccionada(event) {
      const file = event.target.files[0];
      if (file && this.validarImagen(file)) {
        this.curricula_form.imagenNueva = file;
        this.curricula_form.reemplazarImagen = true;
        this.curricula_form.quitarImagenExistente = false;
      } else {
        event.target.value = null;
      }
    },

    reemplazarImagen() {
      this.curricula_form.imagen = null;
      this.curricula_form.reemplazarImagen = true;
      this.curricula_form.quitarImagenExistente = false;
    },

    quitarImagen() {
      this.curricula_form.imagen = null;
      this.curricula_form.imagenNueva = null;
      this.curricula_form.reemplazarImagen = true;
      this.curricula_form.quitarImagenExistente = true;
    },
    async actualizarCurricula() {
  try {
    // Validaciones mejoradas
    if (!this.curricula_form.nombre_curricula || this.curricula_form.nombre_curricula.trim() === '') {
      this.toast("b-toaster-bottom-center", true, "El nombre de la currícula es obligatorio", "warning");
      return;
    }

    if (this.curricula_form.tipo == 0) {
      this.toast("b-toaster-bottom-center", true, "Debe seleccionar un tipo de currícula", "warning");
      return;
    }

    let formData = new FormData();
    
    // Agregar campos con valores por defecto
    formData.append("nombre_curricula", this.curricula_form.nombre_curricula || '');
    formData.append("descripcion", this.curricula_form.descripcion || '');
    formData.append("tipo", this.curricula_form.tipo.toString());
    formData.append("fecha_vigencia_inicio", this.curricula_form.fecha_vigencia_inicio || '');
    formData.append("fecha_vigencia_finalizacion", this.curricula_form.fecha_vigencia_finalizacion || '');
    formData.append("reemplazarImagen", this.curricula_form.reemplazarImagen.toString());
    formData.append("quitarImagenExistente", this.curricula_form.quitarImagenExistente.toString());
    
    // ENVÍO CRUCIAL: Pasar la URL de la imagen existente
    formData.append("existing_image_url", this.curricula_form.imagen || '');

    // Solo adjuntar imagen nueva si existe
    if (this.curricula_form.imagenNueva) {
      formData.append("imagen", this.curricula_form.imagenNueva);
    }

    let url = `/api/curriculas/update/${this.currentCurriculaId}`;
    
    // CORRECCIÓN: Usar PUT en lugar de POST
    const response = await this.$api.post(url, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    let { success, message, color } = response.data;
    if (success) {
      await this.getCurriculas();
      this.resetForm();
      this.curricula_form.editar = false;
      this.ModalCrearCurricula = false;
    }
    this.toast("b-toaster-bottom-center", true, message, color);
  } catch (error) {
    console.error("Error al actualizar:", error);
    this.toast(
      "b-toaster-bottom-center",
      true,
      "Error al actualizar la currícula: " + (error.response?.data?.message || error.message),
      "danger"
    );
  }
}

,
EditMode(item) {
  this.curricula_form.editar = true;
  this.curricula_form.nombre_curricula = item.nombre_curricula || '';
  this.curricula_form.tipo = item.tipo || 0;
  this.curricula_form.descripcion = item.descripcion || '';
  this.curricula_form.fecha_vigencia_inicio = item.fecha_seleccion_inicio || '';
  this.curricula_form.fecha_vigencia_finalizacion = item.fecha_seleccion_termino || '';
  
  // Usar el mismo campo que se muestra en la lista
  this.curricula_form.imagen = item.imagen || item.url_video_presentacion || null;
  
  this.curricula_form.imagenNueva = null;
  this.curricula_form.reemplazarImagen = false;
  this.curricula_form.quitarImagenExistente = false;
  this.currentCurriculaId = item.id;
  this.ModalCrearCurricula = true;
},

    async guardarCurricula() {
      try {
        // Validaciones básicas
        if (!this.curricula_form.nombre_curricula.trim()) {
          this.toast(
            "b-toaster-bottom-center",
            true,
            "El nombre de la currícula es obligatorio",
            "warning"
          );
          return;
        }

        if (this.curricula_form.tipo == 0) {
          this.toast(
            "b-toaster-bottom-center",
            true,
            "Debe seleccionar un tipo de currícula",
            "warning"
          );
          return;
        }

        let formData = new FormData();
        formData.append(
          "nombre_curricula",
          this.curricula_form.nombre_curricula
        );
        formData.append("descripcion", this.curricula_form.descripcion);
        formData.append("tipo", this.curricula_form.tipo);
        formData.append(
          "fecha_vigencia_inicio",
          this.curricula_form.fecha_vigencia_inicio
        );
        formData.append(
          "fecha_vigencia_finalizacion",
          this.curricula_form.fecha_vigencia_finalizacion
        );

        if (this.curricula_form.imagenNueva) {
          formData.append("imagen", this.curricula_form.imagenNueva);
        }

        let url = `/api/curriculas/store`;
        const response = await this.$api.post(url, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        let { success, message, color } = response.data;
        if (success) {
          await this.getCurriculas();
          this.ModalCrearCurricula = false;
          this.resetForm();
        }
        this.toast("b-toaster-bottom-center", true, message, color);
      } catch (error) {
        this.toast(
          "b-toaster-bottom-center",
          true,
          "Error al crear la currícula",
          "danger"
        );
        Bugsnag.notify(
          new Error("Método: guardarCurricula() " + error.message)
        );
      }
    },

    resetForm() {
      this.curricula_form.nombre_curricula = "";
      this.curricula_form.tipo = 0;
      this.curricula_form.descripcion = "";
      this.curricula_form.fecha_vigencia_finalizacion = "";
      this.curricula_form.fecha_vigencia_inicio = "";
      this.curricula_form.imagen = null;
      this.curricula_form.imagenNueva = null;
      this.curricula_form.reemplazarImagen = false;
      this.curricula_form.quitarImagenExistente = false;
      this.curricula_form.editar = false;
    },

    async borrarCurricula() {
      const response = await this.$api.delete(
        `/api/curriculas/destroy/${this.currentCurriculaId}`
      );
      let { success, message, color } = response.data;
      if (success) {
        await this.getCurriculas();
        this.ModalBorrarCurricula = false;
        this.currentCurriculaId = 0;
        this.currentCurriculaNombre = "";
      }
      this.toast("b-toaster-bottom-center", true, message, color);
    },

    ShowModalBorrarCurricula(item) {
      this.currentCurriculaId = item.id;
      this.currentCurriculaNombre = item.nombre_curricula;
      this.ModalBorrarCurricula = true;
    },

    cerrarModalCrearCurricula() {
      this.ModalCrearCurricula = false;
      this.resetForm();
    },

    showModalCrearCurricula() {
      this.resetForm();
      this.ModalCrearCurricula = true;
    },

    async getCurriculas() {
      this.isLoading = true;
      let url = `/api/curriculas/index`;
      const response = await this.$api.get(url);
      let { curricula, success, message, color } = response.data;

      if (success) {
        this.itemsCurriculas = curricula;
      }
      this.toast("b-toaster-bottom-center", true, message, color);
      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
$studioAPPColor: #952f81;
$primary-color: #952f81;
$secondary-color: #6c757d;

.txt_title {
  font-size: 2rem;
  font-weight: 700;
  color: $primary-color;
}

.card {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.card-body {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.card-footer-custom {
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 1rem;
}

.card-hover {
  transition: all 0.3s ease;
  border: 1px solid rgba(0,0,0,0.125);
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.1);
    border-color: $primary-color;
  }
}

.hover-lift {
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  }
}

.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.line-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.object-fit-cover {
  object-fit: cover;
}

.border-4 {
  border-style: solid;
  border-width: 0;
  border-left-width: 4px;
}

.btn-studioAPP {
  color: $studioAPPColor !important;
  border: 1px solid $studioAPPColor;
  
  &:hover, &:active {
    background-color: $studioAPPColor !important;
    color: white !important;
  }
}

// Mejoras de accesibilidad
@media (max-width: 768px) {
  .card-body {
    padding: 1rem;
  }
  
  .btn-group .btn {
    margin-bottom: 0.5rem;
  }
}

// Estados de enfoque mejorados
.btn:focus, .form-control:focus, .form-select:focus {
  box-shadow: 0 0 0 0.2rem rgba(149, 47, 129, 0.25);
  border-color: $primary-color;
}

// Mejora visual para los badges
.badge {
  font-size: 0.75em;
}

// Espaciado consistente
.form-group {
  margin-bottom: 1.5rem;
}

.btn-link {
  font-family: 'poppins', sans-serif;
  font-weight: 600;
  color: #6b20c1;
}
.card-text-container {
  height: 6rem;  
  overflow-y: auto;  
}
.bg-danger{
  background-color: #ed6937 !important;
}
.border-danger{
  border-color: #ed6937 !important;
}
</style>